const md = `# Sharing Demos

The Demo Agent generates **public share links** that recipients can
open without signing in.  Two scopes are available.

## Run-level shares

On any run-detail page, click **Share** → a modal lets you set:

* **Scope:** single run.
* **Expiry:** 24 h, 7 d, 30 d, or no expiry.
* **Optional password:** a one-shot string the recipient must type.

The button returns a URL like
\`https://demo-agent.../share/abcd1234ef\` that renders the run's
video, narration, screenshots, and final MP4 with no login.  Owners
can revoke the link any time from the same modal.

## Folder-level shares

From a folder detail page, the same Share button issues a token that
exposes *every run currently inside the folder* (private runs are
automatically filtered out).  Add a run to the folder later — it
appears in the share immediately.  Remove a run — it disappears
immediately.

## What recipients see

A clean, read-only view branded with **Eyvo Demo Agent** that shows:

1. A header card with the workflow name + persona + duration.
2. The final MP4 inline (or the Playwright video if the pipeline
   wasn't run).
3. The narration text.
4. A screenshot gallery in step order.
5. **No** raw step log, no API endpoints, no admin buttons.

## Audit trail (admins)

Top-nav → **Shares** shows every active token, who created it, what it
points at, expiry, and a one-click revoke.  Revoked tokens 404
immediately.
`;

export default md;
